import request from '@/utils/request'

// 获取所有角色信息
export function getAllRoles() {
  return request({
    url: '/hrApi/role/all',
    method: 'get'
  })
}

// 分页查询角色信息
export function getPageList(params) {
  return request({
    url: '/hrApi/role',
    method: 'get',
    params: params
  })
}

// 新增或编辑角色
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/role',
    method: 'post',
    data: data
  })
}

// 删除角色
export function deleteData(id) {
  return request({
    url: '/hrApi/role/' + id,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/role.js